var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _vm.editable
        ? _c("div", { staticClass: "input-group my-2" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newTodoText,
                  expression: "newTodoText"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtTaskPlaceholder")
              },
              domProps: { value: _vm.newTodoText },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.addTodo.apply(null, arguments)
                },
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.newTodoText = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary dropdown-toggle",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.types.find(e => e.id === _vm.newType).name) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dropdown-menu" },
                _vm._l(_vm.types, function(type) {
                  return _c(
                    "a",
                    {
                      key: type.id,
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.newType = type.id
                        }
                      }
                    },
                    [_vm._v("\n          " + _vm._s(type.name) + "\n        ")]
                  )
                }),
                0
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.todos, function(todo) {
        return _c(
          "div",
          {
            key: todo.id,
            staticClass: "todo-item-wrapper",
            class: _vm.getTypeBorderClass(todo.type)
          },
          [
            _c("Entry", {
              attrs: {
                todo: todo,
                cells: _vm.cells,
                editable: _vm.editable,
                editorMode: _vm.editorMode,
                deletable: _vm.canDeleteItemFn(todo)
              },
              on: {
                change: function($event) {
                  return _vm.notifyChange(_vm.todos)
                },
                remove: function($event) {
                  return _vm.removeTodo(todo)
                }
              }
            }),
            _vm._v(" "),
            _vm.showTypeBadge(todo.type)
              ? _c(
                  "span",
                  {
                    staticClass: "type-badge-hover",
                    class: _vm.getTypeBadgeClass(todo.type)
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.getTypeName(todo.type)) + "\n    "
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "footer",
        {
          staticClass: "my-2 d-flex justify-content-between align-items-center"
        },
        [
          _c("span", { staticClass: "small text-muted" }, [
            _vm._v(
              _vm._s(_vm.remaining) + " " + _vm._s(_vm.$t("txtTaskRemaining"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "small font-weight-bold text-secondary" }, [
            _vm._v(
              _vm._s(_vm.progressPercentage) + "% " + _vm._s(_vm.$t("txtDone"))
            )
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }